module.exports = __webpack_public_path__ + "assets/img/27_1437.e60051a3.jpg";